import isBrowser from 'utils/isBrowser';
import { Experiment, Variant } from 'experiments/enums';

export function getActiveExperiment(): [Experiment, Variant][] {
  if (isBrowser()) {
    return window.tmsActiveExperiment ?? [];
  }
  return [];
}

export function getActiveVariants(): Variant[] {
  return getActiveExperiment().map(([, variant]) => variant);
}

export function hasActiveExperiment(): boolean {
  return getActiveExperiment().length > 0;
}

export function getExperimentsLoggingStructure(): {
  experimentName: string;
  experimentId: number;
  variantName: string;
  variantId: number;
}[] {
  return getActiveExperiment().map(([experiment, variant]) => ({
    experimentName: experiment.name,
    experimentId: experiment.id,
    variantName: variant.name,
    variantId: variant.id,
  }));
}

export function getSerializedExperimentsInfo(): string {
  return getExperimentsLoggingStructure()
    .map((obj) => JSON.stringify(obj))
    .join(' ');
}

export function getExperimentInfoForTmsLogging():
  | { name: string; value: string }[]
  | [] {
  const loggingStructure = getExperimentsLoggingStructure().map(
    ({ experimentName, experimentId, variantName, variantId }, index) => [
      {
        name: `user-experiment-${index + 1}-experiment-id`,
        value: `${experimentId}`,
      },
      {
        name: `user-experiment-${index + 1}-variant-id`,
        value: `${variantId}`,
      },
      {
        name: `user-experiment-${index + 1}-experiment-name`,
        value: experimentName,
      },
      {
        name: `user-experiment-${index + 1}-variant-name`,
        value: variantName,
      },
    ]
  );

  return loggingStructure.flat();
}
